import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Device } from "../data/Device";

async function get(): Promise<Device[]> {
    const response = await ApiClient({ url: "/devices", method: "GET" });

    if (response.status === 200) {
        return response.data;
    }
    throw new Error(response.data);
}

export function useGetDeviceQuery() {
    return useQuery<Device[]>({
        queryKey: ["get-devices"],
        queryFn: get,
        refetchOnWindowFocus: false,
    });
}